module.exports = __webpack_public_path__ + "media/images/common/main-d6e4c5a45ca043940912dbbae299e9e6.png";